/*
 * @Description: cookie操作
 * @LastEditors: Ji Yinghao
 * @Date: 2019-05-05 15:13:07
 * @LastEditTime: 2019-10-25 18:14:13
 */
export default {
    // 设置cookie
    setCookie: function(name, value, day) {
        var Days = day;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    },
    // 获取cookie
    getCookie: function(name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr == document.cookie.match(reg))
            return eval('(' + unescape(arr[2]) + ')');

        else
            return null;
    },
    // 删除cookie
    delCookie: function(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },
    // 获取localStorage
    getLocalStorage: function(key) {
        var value = localStorage.getItem(key);
        if (value) {
            try {
                var value_json = JSON.parse(value);
                if (typeof(value_json) === 'object') {
                    return value_json;
                } else if (typeof(value_json) === 'number') {
                    return value_json;
                }
            } catch (e) {
                return value;
            }
        } else {
            return false;
        }
    },
    // 设置localStorage
    setLocalStorage: function(key, value) {
        localStorage.setItem(key, value);
    },
    // 删除localStorage
    removeLocalStorage: function(key) {
        localStorage.removeItem(key);
    },
    // 清空全部的localStorage
    clearLocalStorage: function() {
        localStorage.clear();
    }

}